import qs from 'qs';
import oikosApi from '../../../services/oikos';
import { notifySuccess } from '../../../utils/notify';
import { isPedidoCompraComContrato } from '../../Template/Doc/compraCotacaoTableUtils';
import {
  CONTR_FORN_STATUS_ATIVO,
  CONTR_FORN_STATUS_EM_ASSINATURA,
  isCriarContratoDiretoCompraCotacao,
} from './contrFornApprovalRules';
import { fetchCompraCotacaoById, fetchContrFornRecordForEmail } from './contrFornEmailUtils';
import { sendContratacaoFornecedorEmailByContrFornId } from './sendContratacaoFornecedorEmailByContrFornId';

async function fetchPedidoCompraComContrato(pedidoCompraId) {
  const id = Number(pedidoCompraId) || 0;
  if (!id) return false;
  try {
    const res = await oikosApi.get(`/?${qs.stringify({
      action: 'get',
      table: 'pedidoCompra',
      data: { pedidoCompra_id: id },
      fields: {
        pedidoCompra_id: 'pedidoCompra_id',
        pedidoCompra_comContrato: 'pedidoCompra_comContrato',
      },
    })}`);
    return isPedidoCompraComContrato(res?.data?.[0]);
  } catch (error) {
    console.error('Erro ao buscar tipo de ordem de compra:', error);
    return false;
  }
}

const hasContrFornParte = (contrForn = {}) => {
  const parteTab = String(contrForn.contrForn_parteTab || '').trim().toLowerCase();
  const parteId = Number(contrForn.contrForn_parteId) || 0;
  return (parteTab === 'pf' || parteTab === 'pj') && parteId > 0;
};

/**
 * Efeitos colaterais ao aprovar task de contrato (taskTp_id = 3).
 * - Ordem sem contrato e sem parte: Ativo, sem e-mail.
 * - Criar contrato direto: Em assinatura, sem e-mail.
 * - Demais (com contrato): status 1 + e-mail ao fornecedor.
 */
export async function applyContrFornApprovalTaskOutcome(contrFornId) {
  const id = Number(contrFornId) || 0;
  if (!id) return { sentEmail: false };

  const contrForn = await fetchContrFornRecordForEmail({ contrFornId: id });
  const compraCotacao = await fetchCompraCotacaoById(contrForn?.compraCotacao_id);
  const isComContrato = await fetchPedidoCompraComContrato(compraCotacao?.pedidoCompra_id);
  const isCriarDireto = isCriarContratoDiretoCompraCotacao(compraCotacao);

  if (!hasContrFornParte(contrForn) && !isCriarDireto && !isComContrato) {
    await oikosApi.post('/', {
      action: 'update',
      table: 'contrForn',
      data: {
        contrForn_id: id,
        contrFornStatus_id: CONTR_FORN_STATUS_ATIVO,
      },
    });
    notifySuccess('Contrato aprovado.');
    return { sentEmail: false, statusId: CONTR_FORN_STATUS_ATIVO };
  }

  if (isCriarDireto) {
    await oikosApi.post('/', {
      action: 'update',
      table: 'contrForn',
      data: {
        contrForn_id: id,
        contrFornStatus_id: CONTR_FORN_STATUS_EM_ASSINATURA,
      },
    });
    notifySuccess('Contrato aprovado. Em assinatura.');
    return { sentEmail: false, statusId: CONTR_FORN_STATUS_EM_ASSINATURA };
  }

  await oikosApi.post('/', {
    action: 'update',
    table: 'contrForn',
    data: {
      contrForn_id: id,
      contrFornStatus_id: 1,
    },
  });

  const emailSent = await sendContratacaoFornecedorEmailByContrFornId(id);
  if (emailSent) {
    notifySuccess('Contrato aprovado e e-mail enviado ao fornecedor.');
  }
  return { sentEmail: emailSent, statusId: 1 };
}
